import React, {useRef} from 'react'
import {useDrag, useDrop} from 'react-dnd'

const SortableItem = ({id,  index, moveCard, element, children, endDrag = () => {}, isDraggable = true}) => {
    const ref = useRef(null);
    const [, drop] = useDrop({
        accept: 'card',
        hover(item, monitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

            //get horizontal middle
            //const hoverMiddleZ = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;

            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            //const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            const hoverClientZ = clientOffset.z - hoverBoundingRect.left;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientZ < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientZ > hoverMiddleY) {
                return
            }
            // Time to actually perform the action
            moveCard(dragIndex, hoverIndex, element);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    });
    const [{isDragging}, drag] = useDrag({
        item: {type: 'card', id, index},
        canDrag: isDraggable,
        end: () => {
           endDrag()
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    const opacity = isDragging ? 0 : 1;
    drag(drop(ref));
    return (
        <span
            tabIndex={-1}
            ref={isDraggable ? ref : null}
            style={{opacity, width: '100%'}}
            onMouseDown={element && element.disabled ? () => {} : (e) => {e.stopPropagation()}}
        >
            {children}
        </span>
    )
};
export default SortableItem
